import $ from 'jquery';

export default {
	trim: function(val) {
		return $.trim(val);
	}
};


// WEBPACK FOOTER //
// ./src/util/standardFormatters.js